<template lang="pug">
    div(id="searchplaces")
        v-list()
            v-list-item(id="waypoint" v-for="(wp, idx) in waypoints"
                        :key="wp.id")
                v-container(style="width: 10%; margin-left: 0px; margin-right: 0px")
                    v-row(v-if="idx != 0")
                        v-btn(@click="moveWaypointUp(wp.id)" x-small icon)
                            v-icon arrow_drop_up
                    v-row(v-if="idx != waypoints.length - 1")
                        v-btn(@click="moveWaypointDown(wp.id)" x-small icon)
                            v-icon arrow_drop_down
                WaypointSearch(:waypoint="wp" :label="getLabelWaypoint(idx)" @waypointLocationChanged="refreshRoute()"
                                v-touch="{ up: () => moveWaypointUp(wp.id), down: () => moveWaypointDown(wp.id) }")
                v-tooltip(v-if="idx != 0" right)
                    template(v-slot:activator="{ on }")
                        v-btn(@click="removeWaypoint(wp.id)" text icon v-on="on")
                            v-icon remove
                    span Remove waypoint
            v-list-item()
                v-tooltip(right)
                    template(v-slot:activator="{ on }")
                        v-btn(@click="addWaypoint" text icon v-on="on")
                            v-icon add
                    span Add waypoint
        v-tooltip(v-if="waypoints.length>=2" right)
            template(v-slot:activator="{ on }")
                v-btn(@click="getRoute" text icon v-on="on")
                    v-icon directions_bike
            span Get regular route

        v-tooltip(v-if="waypoints.length >= 2" right)
            template(v-slot:activator="{ on }")
                v-btn(@click="getFastRoute" text icon v-on="on")
                    v-icon mdi-bike-fast
            span Get fast route

        v-tooltip(v-if="waypoints.length >= 2" right)
            template(v-slot:activator="{ on }")
                v-btn(@click="getWalkRoute" text icon v-on="on")
                    v-icon mdi-walk
            span Get walk route

        v-tooltip(v-if="waypoints.length >= 2" right)
            template(v-slot:activator="{ on }")
                v-btn(@click="getHikeRoute" text icon v-on="on")
                    v-icon mdi-hiking
            span Get hike route

        v-progress-circular(v-if="requesting_cs" indeterminate color="primary")
        v-tooltip(v-if="(cur_path.distance != 0 || zoomLevel >= 10 ) && !requesting_cs" right)
            template(v-slot:activator="{ on }")
                v-btn(@click="getCampsites" icon v-on="on")
                    v-img(src="./../assets/camping_tent.svg" contain max-width="36" max_height="36") 
            span Get camping sites around
        v-tooltip(v-if="campsites_displayed && !requesting_cs")
            template(v-slot:activator="{ on }")
                v-btn(@click="hideCampsites" text icon v-on="on")
                    v-img(src="./../assets/camping_tent_stroke.svg" contain max-width="36" max_height="36")
            span Hide campsites
        
        v-progress-circular(v-if="requesting_ts" indeterminate color="primary")    
        v-tooltip(v-else-if="!train_stations_displayed" right)
            template(v-slot:activator="{ on }")
                v-btn(@click="getTrainStations" text icon v-on="on")
                    v-icon train
            span Get train stations
        v-tooltip(v-else right)
            template(v-slot:activator="{ on }")
                v-btn(@click="hideTrainStations" text icon v-on="on")
                    v-img(src="./../assets/train_stroke.svg" contain max-width="36" max_height="36")
            span Hide train stations
        v-btn(v-if="cur_path.distance > 0" @click="sharePath" text icon)
            v-icon share
        v-tooltip(v-if="cur_path.distance > 0" right)
            template(v-slot:activator="{ on }")
                v-btn(@click="getGpx" text icon v-on="on")
                    v-icon download
            span Get GPX
    
        
        v-switch(v-model="do_live_localize" label="Live localization")

        v-card(v-if="cur_path.duration > 1")
            h3() Distance:
            p {{distance_str}}
            h3() Duration:
            p {{duration_str}}
            h3() Total ascent:
            p {{ascent}} m
            h3() Total descent:
            p {{descent}} m
</template>

<script>
var _ = require("lodash");
var togpx = require('togpx');

const WaypointSearch = () => import("./WaypointSearch.vue");
import { RouteType, APIRoute } from './../js/api_route'
import { getPrettyTime, getPrettyDistance } from './../js/utils'
import { app_state, app_mgr, OnLiveLocalizationChanged, OnChangedWaypoint } from './../js/app_state'
import { APIPOI } from './../js/api_poi'
import { app_log } from './../js/app_log'



export default {
  data: () => ({
    waypoints: app_state.waypoints,
    do_live_localize: false,
    cur_path: app_state.current_path,
    search_radius: 10000,
    requesting_cs: false,
    requesting_ts: false,
    current_route_type: RouteType.REGULAR,
    train_stations_displayed: false,
    campsites_displayed: false,
    ascent: 0,
    descent: 0,
  }),

  props: {
    zoomLevel: Number,
  },

  components: {
    WaypointSearch,
  },

  mounted() {
    OnLiveLocalizationChanged.push(() => {
      this.onLiveLocalizationChanged();
    });
    OnChangedWaypoint.push(() => {
      this.onChangedWaypoint();
    });
  },

  created() {
    this.debouncedRefreshRoute = _.debounce(this.refreshRoute, 500);
  },

  methods: {
    getLabelWaypoint(idx) {
      if (idx === 0) return "From";
      else if (idx === this.waypoints.length - 1) return "To";
      return "By";
    },

    getRouteCommon() {
      const wp_coord = [];
      for (const wp of this.waypoints) {
        wp_coord.push([wp.lon, wp.lat]);
      }
      APIRoute.getRoute(wp_coord, this.current_route_type)
        .then((data) => {
          app_mgr.setCurrentPath(
            data.distance,
            data.duration,
            data.features,
            data.features_collection,
            data.ascent,
            data.descent
          );
          this.ascent = data.ascent;
          this.descent = data.descent;
        })
        .catch(() => app_log.warn("Can't get a route for these points"));
    },

    getRoute() {
      this.current_route_type = RouteType.REGULAR;
      this.getRouteCommon();
    },

    getFastRoute() {
      this.current_route_type = RouteType.FAST;
      this.getRouteCommon();
    },

    getWalkRoute() {
      this.current_route_type = RouteType.WALK;
      this.getRouteCommon();
    },

    getHikeRoute() {
      this.current_route_type = RouteType.HIKE;
      this.getRouteCommon();
    },

    refreshRoute() {
      if (app_state.current_path.distance != 0) {
        // then a path might have already been computed earlier
        this.getRouteCommon();
      }
    },

    getCampsites() {
      const search_area = app_mgr.getCurrentBoundingBox();
      const prom = APIPOI.getCampsites(search_area);
      this.requesting_cs = true;
      prom.then((data) => {
          if (data.length > 0) {
            this.campsites_displayed = true;
          } else {
            app_log.error("Could not find campsites in this area :(");
          }
          for (let el of data) {
            app_mgr.addCampsite(el.pos, el.name, el.tags);
          }
        })
        .catch((err) => {
          app_log.error(err);
        })
        .finally(() => {
          this.requesting_cs = false;
        });
    },

    getTrainStations() {
      const current_bb = app_mgr.getCurrentBoundingBox();
      this.requesting_ts = true;
      APIPOI.getTrainStations(current_bb)
        .then((data) => {
          app_mgr.clearTrainStations();
          for (let ts of data) {
            app_mgr.addTrainStation(ts.pos, ts.name, ts.tags);
          }
          this.train_stations_displayed = app_state.train_stations.length > 0; // Can't get reactivity working on this one
        })
        .catch((err) => {
          app_log.error(err);
        })
        .finally(() => {
          this.requesting_ts = false;
        });
    },

    getGpx() {
      /* global L : true*/
      const geo_json = L.geoJson(app_state.current_path.features_collection).toGeoJSON();
      const gpx = togpx(geo_json);

      const filename = "my_path.gpx";
      const pom = document.createElement('a');
      const bb = new Blob([gpx], {type: 'text/gpx'});

      pom.setAttribute('href', window.URL.createObjectURL(bb));
      pom.setAttribute('download', filename);

      pom.dataset.downloadurl = ['text/gpx', pom.download, pom.href].join(':');
      pom.draggable = true; 
      pom.classList.add('dragout');

      pom.click();
    },

    hideTrainStations() {
      app_mgr.clearTrainStations();
      this.train_stations_displayed = app_state.train_stations.length > 0; // Can't get reactivity working on this one
    },

    addWaypoint() {
      app_mgr.addWaypoint(0, 0, 0);
    },

    removeWaypoint(wp_id) {
      app_mgr.removeWaypoint(wp_id);
      this.refreshRoute();
    },

    moveWaypointUp(wp_id) {
      app_mgr.moveWaypointUp(wp_id);
      this.$forceUpdate();
      this.refreshRoute();
    },

    moveWaypointDown(wp_id) {
      app_mgr.moveWaypointDown(wp_id);
      this.$forceUpdate();
      this.refreshRoute();
    },

    onLiveLocalizationChanged() {
      this.do_live_localize = app_state.live_localization;
    },

    onChangedWaypoint() {
      this.debouncedRefreshRoute();
    },

    hideCampsites() {
      app_mgr.clearCampsites();
      this.campsites_displayed = false;
    },

    sharePath() {
      // encode path in url:
      const wp_length = app_state.waypoints.length;
      let path_as_str =
        "https://biketrainmap.fabzi.fr/dir/" +
        app_state.waypoints[0].toString();
      path_as_str += "/" + app_state.waypoints[wp_length - 1].toString();
      if (wp_length >= 3) {
        path_as_str += "/";
        for (let i = 1; i < wp_length - 2; i++) {
          path_as_str += app_state.waypoints[i].toString() + ",";
        }
        path_as_str += app_state.waypoints[wp_length - 2].toString();
      }
      const uri = encodeURI(path_as_str);
      navigator.clipboard.writeText(uri).catch(() => {
        app_log.error("Cannot copy URL to clipboard :(\n" + uri);
      });
    },
  },

  computed: {
    distance_str() {
      return getPrettyDistance(app_state.current_path.distance);
    },

    duration_str() {
      return getPrettyTime(this.cur_path.duration);
    },
  },

  watch: {
    do_live_localize(new_val) {
      app_mgr.setLiveLocalizationState(new_val);
    },
  },
};
</script>


<style scoped>
#searchplaces {
  margin-top: 10px;
  margin-left: 0px;
  margin-right: 10px;
}
#waypoint {
  margin-top: 0px;
  padding-top: 0px;
  padding-right: 0px;
  padding-left: 0px;
}
</style>


